import axios from 'axios';
import R from 'ramda';

var calculateParentStatus = function (status) {
  switch (status) {
    case 'Preliminary Proposal':
    case 'Final Proposal':
    case 'Final Submittal':
    case 'Under Review':
    case 'On Hold':
    case 'Expired':
    case 'No Status':
      return 'Proposed';
    case 'Approved':
    case 'Planned':
    case 'In Design':
    case 'Procurement':
    case 'Out to Bid':
      return 'Approved';
    case 'Construction':
      return 'Construction';
    case 'Complete':
      return 'Complete';
    default:
      return null;
  }
}

var formattedStatus = function (status, subStatus) {
  if (status !== subStatus) {
    return `${status} - ${subStatus}`;
  }

  return status;
}

export default {
  loadProjects () {
    return new Promise(resolve => {
      axios.get('https://datahub.arlingtonva.us/api/HousingBuilding/HighlightedDevelopmentProject?format=json').then((result) => {
        const projects = result.data.map(project => {
          if (project.projectCoordinates) {
            let projectTypeList = project.projectTypeList || '';

            let coords = null;
            if (project.projectCoordinates !== 'undefined' && project.projectCoordinates !== 'null') {
              const temp = JSON.parse(project.projectCoordinates.replace(/lat/g, '\'lat\'').replace(/lng/g, '\'lng\'').replace(/,]/g, ']'));
              coords = R.map(m => {
                let crds = null;
                if (m.coordinates && m.coordinates.replace) {
                  crds = JSON.parse(m.coordinates.replace(/'lat'/g, '"lat"').replace(/'lng'/g, '"lng"'));
                } else if (m.coordinates && m.coordinates.push) {
                  crds = m.coordinates.map(m => { return { lat: m['\'lat\''], lng: m['\'lng\''] } });
                } else if (m.coordinates && m.coordinates["'lat'"] && m.coordinates["'lng'"]) {
                  // console.log('Does this hit?')
                  crds = {
                    lat: m.coordinates["'lat'"],
                    lng: m.coordinates["'lng'"]
                  }
                } else {

                }

                return {
                  shape: m.shape,
                  coordinates: crds
                }
              })(temp);
            }

            const parentStatus = calculateParentStatus(project.projectStatusCode);
            const content = `${formattedStatus(parentStatus, project.projectStatusCode)}<br />${projectTypeList.replace(',', ', ')}`;

            let types = projectTypeList.split(',').map(p => { return { name: p } });
            if (projectTypeList.indexOf('Form Based Code') > -1) {
              types.push({ name: 'Site Plan Project' });
            }
            return {
              title: project.projectTitleText,
              status: parentStatus,
              subStatus: project.projectStatusCode,
              url: project.projectUrlText,
              id: project.highlightedDevelopmentProjectKey,
              projects: types,
              developerName: project.developerName,
              rpc: project.realEstatePropertyCode,
              completionDate: project.completionDate,
              address: project.developmentProjectAddressText,
              buildingPermitList: project.buildingPermitList,
              content: content,
              shapes: coords,
              hideProject: project.hidePolygonInd,
              hideUrl: project.privateUrlInd
            }
          }
        });
        const filtered = projects
          .filter(project => project && project.shapes && project.shapes[0].coordinates && !project.hideProject)
          .filter(p => {
            var condition = (p.projects.find(f => f.name === 'Neighborhood') ||
              p.projects.find(f => f.name === 'National Historic Place') ||
              p.projects.find(f => f.name === 'Local Historic District') ||
              p.projects.find(f => f.name === 'Historic Resources Inventory') ||
              (p.projects.length === 1 && p.projects[0].name === '') ||
              p.projects.length === 0);

            return !condition;
          });
        resolve(filtered);
      });
    });
  },
  loadDailyWork () {
    return new Promise(resolve => {
      axios.get('https://datahub.arlingtonva.us/waze/roadclosuresjson').then(result => {
        const roadClosures = result.data.map(closure => {
          const paths = [];
          paths.push({
            lat: closure.VwDisruption.StartStreetSectionDisruptionLatitudeCrd,
            lng: closure.VwDisruption.StartStreetSectionDisruptionLongitudeCrd
          });
          paths.push({
            lat: closure.VwDisruption.EndingStreetSectionDisruptionLatitudeCrd,
            lng: closure.VwDisruption.EndingStreetSectionDisruptionLongitudeCrd
          });

          return {
            id: closure.VwDisruption.DisruptionKey,
            shapes: {
              0: {
                shape: 'polyline',
                coordinates: paths
              }
            },
            status: 'Construction',
            subStatus: 'Construction',
            projects: [{ name: 'Daily Work' }],
            title: closure.VwDisruption.AffectedStreetName || '',
            content: closure.VwDisruption.DisruptionDsc,
            url: 'https://transportation.arlingtonva.us/streets/street-maintenance/'
          }
        });
        var uniq = R.uniqBy(a => `${a.title}|${a.content}`, roadClosures);
        resolve(uniq);
      });
    })
  },
  loadPermitsForProject (project) {
    return new Promise(resolve => {
      axios.get(`https://datahub.arlingtonva.us/api/HousingBuilding/HighlightedDevelopmentProjectPermit?format=json&$filter=HighlightedProjectId%20eq%20${project.id}`)
        .then(response => {
          resolve(response.data);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/projects.service.js